
define('app/dashboard/leagues/instances/views/lgPositionSettingsView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/leaguePositionModel',
	'known/models/productTypeModel'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		LeaguePositionModel,
		ProductTypeModel){

	//Views
	var EditPositionFooterView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			
			this.showEditForm();
			
			this.listenTo(this.event, 'default', this.showEditForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showEditForm);
			this.listenTo(this.event, 'success', this.showEditForm);
			
			_.bindAll(this, 'submitEditForm');
			
			$(this.el).find(".editPosFormSubmit").on('click', this.submitEditForm);
		},
		
		hideAll: function () {
			this.$(".editPosFormSubmit").hide();
			this.$(".editPosFormCancel").hide();
		},
		
		submitEditForm: function () {
			this.event.trigger("save");
		},
		
		showEditForm: function () {
			this.hideAll();
			this.$(".editPosFormCancel").show();
			this.$(".editPosFormSubmit").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var EditPositionContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.position = options.position;
			this.prodType = options.prodType;
			
			this.defaultColorList = [
			                         '#fea3aa','#ff4040','#bc2626', //red
			                         '#a9dba9','#39e639','#22ab22', //green
			                         '#ffe9a6','#ffff00','#8f8f00',//yellow
			                         '#7bd7fd','#4671d5','#274b9f', //blue
			                         '#f2a2e8','#9f3ed5','#73239f', //purple
			                         '#fbbf69','#ffaa00','#8f5f00', //orange
			                         '#ffffff','#bbbbbb','#000000']; //white/black
			
			this.editInput = $(this.el).find('.editPosColorInput');
			this.editColorDisplay = $(this.el).find('.posColorPreview');			
			this.defaultPreviewDivs = $(this.el).find('.colorDefaultPreviews');
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'updateColor');
			_.bindAll(this, 'defaultSelected');
			
			this.listenTo(this.event, 'save', this.submitEditPosition);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.editPositionForm);
			this.listenTo(this.event, 'success', this.editPositionForm);
			
			this.editInput.on('keyup', this.updateColor);
			
			//Error handling
			this.listenTo(this.event, 'error:starters', this.errorStarters);
			this.listenTo(this.event, 'error:color', this.errorColor);
			this.listenTo(this.event, 'error:min', this.errorMin);
			this.listenTo(this.event, 'error:max', this.errorMax);
			
			this.buildEl();
		},
		
		buildEl: function() {
			var previewRowDiv = $('<div class="dropdownDivItem posPreviewRow"></div>');
			
			for(var i=0; i < this.defaultColorList.length; i++) {
				if(i%3 == 0){
					if(i>0){
						this.defaultPreviewDivs.append(previewRowDiv);
					}
					
					previewRowDiv = $('<div class="dropdownDivItem posPreviewRow"></div>');
				}
				
				var previewDiv = $('<div class="posPreviewRowItem">&nbsp;</div>');
				
				previewDiv.css({ "background-color": this.defaultColorList[i]});
				previewDiv.on('click', {hexColor: this.defaultColorList[i]}, this.defaultSelected);
				previewRowDiv.append(previewDiv);
			}
			
			this.defaultPreviewDivs.append(previewRowDiv);
		},
		
		render: function() {
			//Initialize fields
			this.$(".editPosStartersInput").val(this.position.get("starters"));
			this.$(".editPosMinInput").val(this.position.get("min"));
			this.$(".editPosMaxInput").val(this.position.get("max"));
			this.$(".editPosColorInput").val(this.position.get("color"));
			
			return this;
		},
		
		updateColor: function() {
			var inputVal = this.editInput.val();
			
			if(!inputVal || inputVal.length < 3){
				this.errorColor("LENGTH");
				return false;
			}
			
			if(inputVal.charAt(0) == "#"){
				inputVal = inputVal.substr(1);
			}
			
			var hexColorRegex = /^#?(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/; 
			
			if(hexColorRegex.test(inputVal)){
				this.editColorDisplay.css({ "background-color": '#' + inputVal});
				this.hideColorError();
				
				return '#' + inputVal;
			} else {
				this.errorColor("COLORHEX");
				
				return null;
			}
			
		},
		
		defaultSelected: function(event){
			this.editInput.val(event.data.hexColor);
			this.updateColor();
		},
		
		submitEditPosition: function () {
			if(!this.submittedData.isSubmitted){
				var min = parseInt(this.$(".editPosMinInput").val());
				var max = parseInt(this.$(".editPosMaxInput").val());
				var starters = parseInt(this.$(".editPosStartersInput").val());
				
				if(min > max){
					this.errorMax("MIN");
				} else if (starters > max){
					this.errorMax("STARTERS");
				} else {
					this.event.trigger("saving");
					
					this.submittedData.isSubmitted = true;
					this.position.save({
						color: this.$(".editPosColorInput").val(),
						min: min,
						max: max,
						starters: starters
					},{wait: true,
						success : this.successCallback, 
						error : this.errorCallback
					});
				}				
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$(".editPosStartersGrp").removeClass("error");
			this.$(".editPosStartersInput").removeClass("error");
			this.$(".editPosStartersErrMsg").hide();
			
			this.$(".editPosMinGrp").removeClass("error");
			this.$(".editPosMinInput").removeClass("error");
			this.$(".editPosMinErrMsg").hide();
			
			this.$(".editPosMaxGrp").removeClass("error");
			this.$(".editPosMaxInput").removeClass("error");
			this.$(".editPosMaxErrMsg").hide();
			
			this.hideColorError();
		},
		
		hideColorError: function() {
			this.$(".editPosColorGrp").removeClass("error");
			this.$(".editPosColorInput").removeClass("error");
			this.$(".editPosColorErrMsg").hide();
		},
		
		editPositionForm: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		errorStarters : function (errorCode) {
			this.$(".editPosStartersGrp").addClass("error");
			this.$(".editPosStartersInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editPosStartersErrMsg").html("Number of Starters is empty");
					this.$(".editPosStartersErrMsg").show();
					break;
				case "LENGTH":
					this.$(".editPosStartersErrMsg").html("Number of starters must be between 1 and 99");
					this.$(".editPosStartersErrMsg").show();
					break;
				case "NUMERIC":
					this.$(".editPosStartersErrMsg").html("Number of starters may only contain numeric characters");
					this.$(".editPosStartersErrMsg").show();
					break;
				default : 
					this.$(".editPosStartersErrMsg").html("Number of starters is invalid");
					this.$(".editPosStartersErrMsg").show();
			}
		},
		
		errorColor : function (errorCode) {
			this.$(".editPosColorGrp").addClass("error");
			this.$(".editPosColorInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editPosColorErrMsg").html("Position color is empty");
					this.$(".editPosColorErrMsg").show();
					break;
				case "LENGTH": 
					this.$(".editPosColorErrMsg").html("Position color hex must be at least 3 characters long");
					this.$(".editPosColorErrMsg").show();
					break;
				case "COLORHEX":
					this.$(".editPosColorErrMsg").html("Position color must be in hexadecimal format (ex: #fff or #ffffff)");
					this.$(".editPosColorErrMsg").show();
					break;
				default : 
					this.$(".editPosColorErrMsg").html("Position color is invalid");
					this.$(".editPosColorErrMsg").show();
			}
		},
		
		errorMin : function (errorCode) {
			this.$(".editPosMinGrp").addClass("error");
			this.$(".editPosMinInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editPosMinErrMsg").html("Minimum number of players is empty");
					this.$(".editPosMinErrMsg").show();
					break;
				case "LENGTH":
					this.$(".editPosMinErrMsg").html("Minimum number of players must be between 1 and 99");
					this.$(".editPosMinErrMsg").show();
					break;
				case "NUMERIC":
					this.$(".editPosMinErrMsg").html("Minimum number of players may only contain numeric characters");
					this.$(".editPosMinErrMsg").show();
					break;
				default : 
					this.$(".editPosMinErrMsg").html("Minimum number of players is invalid");
					this.$(".editPosMinErrMsg").show();
			}
		},
		
		errorMax : function (errorCode) {
			this.$(".editPosMaxGrp").addClass("error");
			this.$(".editPosMaxInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editPosMaxErrMsg").html("Max number of players is empty");
					this.$(".editPosMaxErrMsg").show();
					break;
				case "LENGTH":
					this.$(".editPosMaxErrMsg").html("Max number of players must be between 1 and 99");
					this.$(".editPosMaxErrMsg").show();
					break;
				case "NUMERIC":
					this.$(".editPosMaxErrMsg").html("Max number of players may only contain numeric characters");
					this.$(".editPosMaxErrMsg").show();
					break;
				case "MIN":
					this.$(".editPosMaxErrMsg").html("Max number of players must be less than the minimum number of players");
					this.$(".editPosMaxErrMsg").show();
					break;
				case "STARTERS":
					this.$(".editPosMaxErrMsg").html("Max number of players must be less than the number of starters");
					this.$(".editPosMaxErrMsg").show();
					break;
				default : 
					this.$(".editPosMaxErrMsg").html("Max number of players is invalid");
					this.$(".editPosMaxErrMsg").show();
			}
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var EditPositionMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$(".editPosBodyMessageError").hide();
			this.$(".editPosBodyMessageProcessing").hide();
			this.$(".editPosBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".editPosBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".editPosBodyMessageSuccess").show();
			this.$(".editPosBodyMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".editPosBodyMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var EditPositionView = Backbone.View.extend({
		initialize: function(options) {		
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.position = options.position;
			this.prodType = options.prodType;
			this.prodConfig = options.prodConfig;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			_.bindAll(this, 'formSubmit');
			
			this.message = new EditPositionMessageView({el: this.$(".editPosBodyMessage"), event: this.event});
			this.content = new EditPositionContentView({
					el: this.$(".editPosBodyContent"),
					event: this.event,
					submittedData : this.submittedData,
					userModel: this.userModel, 
					lgInstance: this.lgInstance,
					position: this.position,
					prodType: this.prodType});
			this.footer = new EditPositionFooterView({
				el: this.$(".editPosFooter"), 
				event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
			
			//Setup Form open/hide
			var editPosOpenBtn = this.$(".editPosOpen");
			var editPosCloseBtn = this.$(".editPosFormCancel");
			
			editPosOpenBtn.on('click', {}, this.showView);
			editPosCloseBtn.on('click', {}, this.hideView);
			
			this.$(".editPosBodyContent").submit(this.formSubmit);
		},
		
		render: function () {
			this.content.render();
			
			this.event.trigger("default");
			this.updateVisuals();
			return this;
		},
		
		updateVisuals: function() {
			//Determine whether to show the Edit Team form button
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.prodConfig.CUSTPOS == 'true'
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				this.$(".editPosOpen").show();
			} else {
				this.$(".editPosOpen").hide();
			}
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$(".editPosOpen").show();
			this.$(".removePosOpen").show();
			this.$(".editPosBodyContent").slideUp();
		},
		
		showView: function() {
			this.$(".editPosOpen").hide();
			this.$(".removePosOpen").hide();
			this.$(".editPosBodyContent").slideDown();
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		success: function () {			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}

			this.$(".editPosOpen").show();
			this.$(".removePosOpen").show();
			this.$(".editPosBodyContent").hide();
		},
		
		formSubmit: function(e) {
			e.preventDefault();
			return false;
		},
	    
	    destroyView: function() {
	    	this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	return EditPositionView;  
});